import React, { useEffect, useState } from 'react';
import {
    Grid, Paper
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchclothstklump, fetchclothstklump2 } from '../../../Store/PHPSlice/clothStock';
import { selectClothstklumplist } from '../../Selectors/UploadStock/ReadyMSelector';
import { useParams } from 'react-router-dom';

const ClothStkView = ({ data }) => {
    const issueLumps = data;
    const { Id } = useParams();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const dispatch = useDispatch();
    const lumplist = useSelector(selectClothstklumplist);
    // console.log(lumplist);
    useEffect(() => {
        if (issueLumps === 1) {
            const split = Id?.split('-');
            if (split.length > 1) {
                const ids = {
                    bId: split[0],
                    infoId: split[1]
                };
                // console.log(ids);
                dispatch(fetchclothstklump2(ids));
            }
        } else {
            dispatch(fetchclothstklump(Id));
        }
    }, [Id, issueLumps]);
    // console.log(lumplist)
    useEffect(() => {
        if (issueLumps === 1) {
            if (lumplist?.data4?.length > 0) {
                setLumpRows(lumplist?.data4);
                const totmtr = lumplist?.data4?.reduce((acc, lump) => acc + parseInt(lump.mtr), 0);
                setLumpTotMtr(totmtr);
            }
        } else {
            if (lumplist?.data?.length > 0) {
                setLumpRows(lumplist?.data);
                const totmtr = lumplist?.data?.reduce((acc, lump) => acc + parseInt(lump.mtr), 0);
                setLumpTotMtr(totmtr);
            }
        }
    }, [lumplist, issueLumps]);

    return (
        <>
            <div className="lump-content">
                <h3>Lump Details </h3>

                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Location</th>
                            <th>Rack</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Lump Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lumpRows.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td>
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="locNm"
                                            value={lumpRow.locNm}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="rack"
                                            value={lumpRow.rack}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="color"
                                            value={lumpRow.color}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            value={lumpRow.mtr}
                                            readOnly
                                        />
                                    </td>

                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td> </td>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{lumpTotMtr}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </>
    );
}

export default ClothStkView;
